import { Component } from "react";
import { FormattedMessage } from "react-intl";
import "./portfolio.css";
import video13 from "../../assets/video13.mp4";
import video14 from "../../assets/video14.mp4";
import video15 from "../../assets/video15.mp4";
import video16 from "../../assets/video16.mp4";
import video17 from "../../assets/video17.mp4";
import video18 from "../../assets/video18.mp4";

const data = [
  {
    id: 1,
    image: video13,
    title: "portfolio.title1",
    github: "https://x.com/security_gov/status/1774874373620420769",
    demo: "https://drive.google.com/file/d/1JKSYR83XolxrQoMxYfwtO8IlcQCWdnj4/view?usp=drive_link",
    poster: require("../../assets/13.png"),
  },
  {
    id: 4,
    image: video16,
    title: "portfolio.title4",
    github: "https://x.com/security_gov/status/1772798307544310140",
    demo: "https://drive.google.com/file/d/1m438E9WhjWrwYXzGWGWFiyjA_gJW7vOW/view?usp=drive_link",
    poster: require("../../assets/14.png"),
  },
  {
    id: 3,
    image: video15,
    title: "portfolio.title3",
    github: "https://x.com/security_gov/status/1775594037845626982",
    demo: "https://drive.google.com/file/d/1HV0qyDk9NSfznw_EZCVq-i14LJ43Xsjx/view?usp=drive_link",
    poster: require("../../assets/15.png"),
  },
  {
    id: 2,
    image: video14,
    title: "portfolio.title2",
    github: "https://x.com/security_gov/status/1774529447338676329",
    demo: "https://drive.google.com/file/d/11UkZyx4AAwBvHnpYR7tJlxHrNPyXYaC6/view?usp=drive_link",
    poster: require("../../assets/16.png"),
  },
  {
    id: 5,
    image: video17,
    title: "portfolio.title5",
    github: "https://x.com/security_gov/status/1774812388031648201",
    demo: "https://drive.google.com/file/d/1gNU1P90rZKN9p6pH5cpUp3JW49x6IIBR/view?usp=drive_link",
    poster: require("../../assets/17.png"),
  },
  {
    id: 6,
    image: video18,
    title: "portfolio.title6",
    github: "https://x.com/security_gov/status/1776680862731427948",
    demo: "https://drive.google.com/file/d/1riA3UweFrYDr8q0k_AwZV1S98EKOeBzQ/view?usp=drive_link",
    poster: require("../../assets/18.png"),
  },
];

const Portfolio = ({ recentWorks }) => {
  // state = {
  //   activeButtonIndex: null, // Track the active button
  //   lastPlayedVideo: null, // To store the last played video
  // };

  // handleCopy = (demo, index) => {
  //   // Copy the demo link to clipboard
  //   navigator.clipboard.writeText(demo);

  //   // Set active button index
  //   this.setState({ activeButtonIndex: index });

  //   // Remove the active state after 3 seconds
  //   setTimeout(() => {
  //     this.setState({ activeButtonIndex: null });
  //   }, 3000);
  // };

  // handlePlay = (videoElement) => {
  //   // Pause the previously playing video if it exists
  //   if (
  //     this.state.lastPlayedVideo &&
  //     this.state.lastPlayedVideo !== videoElement
  //   ) {
  //     this.state.lastPlayedVideo.pause();
  //   }

  //   // Set the new video as the last played video
  //   this.setState({ lastPlayedVideo: videoElement });
  // };

  return (
    <section id="portfolio" className="bg-alt p-12">
      <h5>{recentWorks.sectionTitle}</h5>
      <h2>{recentWorks.sectionDescription}</h2>
      <div className="container portfolio__container">
        {recentWorks.works.map((work) => {
          // const isActive = this.state.activeButtonIndex === index; // Check if the button is active
          return (
            <article key={work._key} className="portfolio__item">
              <div style={{ marginBottom: "20px" }}>
                <iframe
                  src={work.video.replace("/view", "/preview")}
                  width="640"
                  height="360"
                  allow="autoplay; encrypted-media"
                ></iframe>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Portfolio;

{
  /* <video
                  poster={poster}
                  controls
                  preload="auto"
                  onPlay={(e) => this.handlePlay(e.target)} // Call handlePlay when the video starts
                >
                  <source src={image} type="video/mp4" />
                  <FormattedMessage id="portfolio.videoFallback" />
                </video>
              </div>
              <div className="portfolio__item-cta">
                <a
                  onClick={() => this.handleCopy(demo, index)}
                  className={`btn btn-primary ${isActive ? "clicked" : ""}`} // Apply active class conditionally
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage id="portfolio.twitter" />
                </a> */
}
